import { InputNumber } from "antd";
import type { InputNumberProps } from "antd";

export default function AppInputNumber<T extends number | string = number>({
  placeholder,
  suffix,
  ...rest
}: InputNumberProps<T>) {
  const resolvedSuffix =
    suffix !== undefined
      ? suffix
      : placeholder
      ? (
          <span
            style={{ color: "#bfbfbf", fontSize: 12, pointerEvents: "none", userSelect: "none" }}
          >
            {placeholder}
          </span>
        )
      : undefined;

  return <InputNumber<T> placeholder={placeholder} suffix={resolvedSuffix} {...rest} />;
}
